<template>
  <v-flex
    xs12
    sm10
    md8
    lg6
  >
    <v-form ref="form" @submit.prevent="add">
      <v-text-field
        v-model="amount"
        label="Amount"
        prefix="$"
        :rules="[required, isCurrency]"
      />
      <v-layout justify-space-around>
        <v-btn type="submit" color="primary" :loading="isLoading">
          Make Payment
        </v-btn>
      </v-layout>
    </v-form>
    <vue-stripe-checkout ref="checkout" :amount="amount * 100" />
  </v-flex>
</template>

<script>
import { db, getUid } from '@/plugins/firebase';
import { required } from '@/util';
import { pick } from 'lodash-es';

export default {
  name: 'TenantPayment',
  data: () => ({
    amount: null,
    owner: null,
    property: null,
    admin: null,
    isLoading: false,
  }),
  async created() {
    const userSnap = await db
      .collection('users')
      .doc(getUid())
      .get();
    Object.assign(this, userSnap.data());
  },
  methods: {
    required,
    isCurrency: value => /^\d+(\.\d{0,2})?$/.test(value) || 'Please input a valid dollar amount',
    async add() {
      if (!this.$refs.form.validate()) return;
      const { token } = await this.$refs.checkout.open();
      this.isLoading = true;
      await db.collection('transactions').add({
        ...pick(this, ['owner', 'admin', 'property']),
        amount: Math.floor(this.amount * 100),
        createdAt: Date.now(),
        tenant: getUid(),
        token: token.id,
      });
      this.isLoading = false;
      this.$router.push('transactions');
    },
  },
};
</script>

<style></style>
